import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { type PropertyStore } from './types';

const initialValues = {
  _id: undefined,
};

export const usePropertyStore = create<PropertyStore>()(
  immer((set, _get) => {
    return {
      ...initialValues,
      setPropertyId: (_id) => {
        set((draft) => {
          draft._id = _id;
        });
      },
    };
  }),
);
